import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { LocationModel } from "@app/models/rest/location";

@Injectable({
  providedIn: "root"
})
export class LocationRestService extends HateoasResourceOperation<LocationModel> {
  constructor() {
    super(LocationModel);
  }
}
